import styled from "styled-components";
import { COLORS, responsive } from "../../../../../styles/constants.style";

export const MyMeetingsWrapper = styled.div`
  display: flex;

  .meetings-container {
    display: flex;
    width: 100%;
    flex-direction: column;
    padding: 0;
    border-radius: 8px;
    background-color: ${COLORS.cirrus_white};
  }

  .title-filter-wrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
    border-bottom: 1px solid ${COLORS.cirrus_black4};
    padding: 16px;
    justify-content: space-between;

    ${responsive.MOBILE`
      flex-direction: column;
      align-items: flex-start;
      gap: 16px;
      padding: 16px 8px;
    `}

    ${responsive.TABLET_LANDSCAPE`
      flex-direction: column;
      align-items: flex-start;
      gap: 16px;
      padding: 16px 8px;
    `}
  }

  .title-wrapper {
    display: flex;
    align-items: center;
  }

  .filter-wrapper {
    display: flex;
    gap: 40px;
    flex-direction: row;

    ${responsive.MOBILE`
      flex-direction: column;
      gap: 16px;
      width: 100%;
    `}

    ${responsive.TABLET_LANDSCAPE`
      flex-direction: column;
      gap: 24px;
      width: 100%;
    `}

    .horizontal-wrapper .mui-select {
      width: 200px;

      ${responsive.MOBILE`
        width: 100%;
      `}
      ${responsive.TABLET_LANDSCAPE`
        width: 300px;
      `}
    }
  }
`;
